import React, { Component } from 'react'
import { connect } from 'react-redux'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import { FlatButton } from 'material-ui'
import FloatingActionButton from 'material-ui/FloatingActionButton'
import ContentAdd from 'material-ui/svg-icons/content/add'
import { bindActionCreators } from 'redux'
import PropTypes from 'prop-types'
import { browserHistory } from 'react-router'
import Header from '../../components/Header/Header'
import CommonLoader from '../../components/CommonLoader/CommonLoader'
import UserDetails from './UserDetails'
import {
  USER_UPDATE_RESET,
  getUserChildrenList,
  markUserInactive
} from '../../actions/userManagement'
import Constants from './contants'
import ConfirmationDialog from '../../components/Dialog/Dialog'

if (process.env.WEBPACK) {
  // eslint-disable-next-line global-require
  require('./style.css')
}

class UserManagement extends Component {
  constructor(props) {
    super(props)
    this.state = {
      openDialog: false,
      usersList: [],
      userData: {},
      isConfirmationDialogOpen: false,
      inactiveUserId: null
    }
  }

  componentDidMount() {
    // eslint-disable-next-line no-shadow
    const { userInfo, getUserChildrenList } = this.props
    const { roles = [] } = userInfo || {}
    if (userInfo) {
      getUserChildrenList(
        '100116958', // techrcm@housing.com is the top hierarchy
        false,
        'v1'
      )
    }
    if (!roles.includes('RCM_USER_MANAGEMENT')) {
      browserHistory.push('/')
    }
  }

  componentWillReceiveProps(nextProps) {
    const { childUserList: oldChildUserList } = this.props
    const { childUserList } = nextProps
    if (oldChildUserList !== childUserList) {
      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({ usersList: childUserList })
    }
  }

  updateUser = userData => {
    this.setState({ openDialog: true, userData })
  }

  confirmationDialogContent = () => {
    return <div>Are you sure you want to mark this user Inactive ?</div>
  }
  handleCloseConfirmationDialog = () => {
    this.setState({
      isConfirmationDialogOpen: false,
      inactiveUserId: null
    })
  }

  handleOpenConfirmationDialog = id => {
    this.setState({
      isConfirmationDialogOpen: true,
      inactiveUserId: id
    })
  }

  setUsersInactive = () => {
    // eslint-disable-next-line no-shadow
    const { userInfo, markUserInactive } = this.props
    const { inactiveUserId } = this.state
    const { id: userId } = userInfo || {}
    markUserInactive(inactiveUserId, userId)
    this.setState({
      inactiveUserId: null,
      isConfirmationDialogOpen: false
    })
  }

  handleAssignAgentDialog = () => {
    this.props.dispatch({
      type: USER_UPDATE_RESET
    })
    this.setState({ openDialog: false })
  }

  handleDialogClose = () => {
    this.props.dispatch({
      type: USER_UPDATE_RESET
    })
    this.setState({ openDialog: false, userData: {} })
  }

  handleDialogOpen = () => {
    this.props.dispatch({
      type: USER_UPDATE_RESET
    })
    this.setState({ openDialog: true, userData: {} })
  }

  render() {
    const { usersList, userData, isConfirmationDialogOpen } = this.state
    const { showLoader } = this.props
    return (
      <div>
        <Header {...this.props} />
        <div className='entity-list'>
          <div>
            <Table onRowSelection={this.handleRowSelection}>
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  <TableHeaderColumn>Id</TableHeaderColumn>
                  <TableHeaderColumn>Name</TableHeaderColumn>
                  <TableHeaderColumn>Email</TableHeaderColumn>
                  <TableHeaderColumn colSpan='2'>Role</TableHeaderColumn>
                  <TableHeaderColumn>Action</TableHeaderColumn>
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {Array.isArray(usersList)
                  ? usersList.map((userInfo, index) => {
                      const { name, email, id, userId, roles } = userInfo || {}
                      return (
                        <TableRow key={index}>
                          <TableRowColumn>{userId}</TableRowColumn>
                          <TableRowColumn>{name}</TableRowColumn>
                          <TableRowColumn>{email}</TableRowColumn>
                          <TableRowColumn colSpan='2'>
                            {roles.join(',')}
                          </TableRowColumn>
                          <TableRowColumn>
                            <React.Fragment>
                              <FlatButton
                                className='sm-info'
                                label='Update'
                                primary
                                onClick={() => this.updateUser(userInfo)}
                              />
                              <FlatButton
                                className='sm-info'
                                label='Inactive'
                                primary
                                onClick={() =>
                                  this.handleOpenConfirmationDialog(id)
                                }
                              />
                            </React.Fragment>
                          </TableRowColumn>
                        </TableRow>
                      )
                    })
                  : null}
              </TableBody>
            </Table>
            <div style={{ position: 'fixed', right: '2%', bottom: '5%' }}>
              <FloatingActionButton onClick={this.handleDialogOpen}>
                <ContentAdd />
              </FloatingActionButton>
            </div>
          </div>
          <UserDetails
            open={this.state.openDialog}
            onRequestClose={this.handleDialogClose}
            handleAssignAgentDialog={this.handleAssignAgentDialog}
            userData={userData}
          />
          <ConfirmationDialog
            title='Inactive User Confirmation'
            dialogContent={this.confirmationDialogContent()}
            handleOpen={isConfirmationDialogOpen}
            handleClose={this.handleCloseConfirmationDialog}
            handleSubmit={this.setUsersInactive}
          />
        </div>
        {showLoader && <CommonLoader propStyle={Constants.style} />}
      </div>
    )
  }
}

UserManagement.propTypes = {
  showLoader: PropTypes.boolean,
  dispatch: PropTypes.func,
  markUserInactive: PropTypes.func,
  getUserChildrenList: PropTypes.func,
  childUserList: PropTypes.object,
  userInfo: PropTypes.object
}

const mapStateToProps = state => {
  return {
    userInfo: state.userInfo,
    agents: state.agents,
    childUserList: state.childUserList,
    showLoader: state.showLoader
  }
}

const mapDispatchToProps = dispatch => {
  return {
    getUserChildrenList: bindActionCreators(getUserChildrenList, dispatch),
    markUserInactive: bindActionCreators(markUserInactive, dispatch),
    dispatch
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(UserManagement)



/** WEBPACK FOOTER **
 ** ./src/containers/UserManagement/index.js
 **/